module.exports = __webpack_public_path__ + "img/AT0000002568465.40d6d6f3.png";